export const BASIS_MAPPING_ALL = 'BASIS_MAPPING_ALL';
export const BASIS_MAPPING_SINGLE = 'BASIS_MAPPING_SINGLE';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
